import { hideScrollbar } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import styled, { css } from 'styled-components';

const { colors, spacing, typography } = themeVariables;

export const breadcrumbNav = css`
  position: relative;

  &[data-left-fade-visible='true'] {
    &:before {
      content: '';
      position: absolute;
      width: var(${spacing.xxl});
      height: 100%;
      left: 0;
      top: 0;
      background-image: linear-gradient(to left, transparent, var(${colors.page.default}));
    }
  }
`;

export const breadcrumbList = css`
  margin: 0;
  list-style-type: none;
  padding: 0;
  white-space: nowrap;
  overflow: scroll;

  ${hideScrollbar}
`;

export const breadcrumbListItem = css`
  display: inline-block;

  & + li::before {
    border-right: 1px solid var(${colors.content.tertiary});
    content: '';
    display: inline-block;
    height: var(${spacing.sm});
    margin: 0 var(${spacing.xs});
    position: relative;
    top: 2px;
    transform: rotate(15deg);
  }

  &:last-child {
    a,
    span {
      color: var(${colors.content.tertiary});
    }
  }
`;

export const breadcrumbLink = css`
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.sm.fontSize});
  font-weight: var(${typography.body.fontWeight});
  text-decoration: none;
  color: var(${colors.content.link});
`;

/**
 * The linked crumb, as a styled component rather than the `css` prop so the
 * rendered element can be swapped through styled-components' polymorphic `as`.
 * The `css` prop cannot do this: it is compiled to a `styled(...)` call hoisted
 * to module scope, where a component chosen per render is not in scope.
 */
export const BreadcrumbLink = styled.a`
  ${breadcrumbLink}
`;
